module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    class: _vm.data,
    attrs: {
      "id": "player1ModThree"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2190.60177,379.404283 C2190.3772,381.779802 2188.65126,382.964278 2186.84887,385.633026 C2184.74592,388.746795 2184.4471,394.629175 2182,399.4117 C2182.48236,400.60152 2186.14105,398.756262 2187.02152,396.825733 C2187.90199,394.895204 2188.57904,393.323109 2188.86824,392.84052 C2189.15745,392.357931 2189.76496,392.445896 2189.91008,392.938104 C2190.0552,393.430313 2189.0188,410.775764 2189.32813,411.657226 C2189.63746,412.538687 2191.75726,412.754306 2192.19997,411.908194 C2192.64267,411.062082 2193.79215,397.366991 2194.00339,397.016216 C2194.21463,396.665441 2194.66572,396.882577 2194.84603,397.089854 C2195.02633,397.297131 2193.40566,411.892369 2193.67489,412.464302 C2193.94413,413.036234 2196.14434,413.133476 2196.42084,412.704269 C2196.69735,412.275062 2198.05561,397.703827 2198.32294,397.3937 C2198.59027,397.083573 2199.06996,397.162837 2199.2418,397.473998 C2199.41363,397.785159 2197.64489,411.776332 2197.93365,412.409257 C2198.22241,413.042183 2200.34684,413.237426 2200.59604,412.641922 C2200.84524,412.046419 2202.51567,397.966732 2202.73948,397.779659 C2202.9633,397.592586 2203.23854,397.635966 2203.41844,397.838992 C2203.59833,398.042019 2202.88235,408.604451 2203.17124,409.207163 C2203.46013,409.809875 2205.0567,410.085845 2205.35585,409.398075 C2205.655,408.710304 2206.77264,382.907221 2206.92915,381.483515 C2207.45072,376.738921 2205.10367,371.530456 2199.52217,371.042692 C2193.94066,370.554927 2191.08401,374.303053 2190.60177,379.404283 Z",
      "id": "player1_right_hand",
      "fill": "#A4CA7A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2202.50458,332.031562 C2207.02187,332.424578 2210.36347,336.384824 2209.96826,340.87702 L2206.39029,381.546217 C2205.99508,386.038413 2202.01271,389.361454 2197.49542,388.968438 C2192.97813,388.575422 2189.63653,384.615176 2190.03174,380.12298 L2193.60971,339.453783 C2194.00492,334.961587 2197.98729,331.638546 2202.50458,332.031562 Z",
      "id": "player1_right_arm_bottom",
      "fill": "#A4CA7A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2207.53068,280.03147 C2212.03224,280.423346 2215.36221,284.372104 2214.96837,288.851267 L2210.33321,341.567842 C2209.93938,346.047005 2205.97087,349.360406 2201.46932,348.96853 C2196.96776,348.576654 2193.63779,344.627896 2194.03163,340.148733 L2198.66679,287.432158 C2199.06062,282.952995 2203.02913,279.639594 2207.53068,280.03147 Z",
      "id": "player1_right_arm_top",
      "fill": "#A4CA7A"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "player1_right_sock",
      "fill": "#CDF1A5",
      "x": "2203",
      "y": "485",
      "width": "20",
      "height": "29"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2180.08142,522.090125 C2184.00342,521.149189 2193.3387,515.072883 2200.80287,509.738472 C2205.75142,511.233785 2218.28576,511.360007 2223.16486,509.738472 C2225.43165,508.985123 2227.41416,508.14194 2227.95084,510.902703 C2228.30863,512.743212 2226.7133,513.908921 2223.16486,514.399831 L2223.16486,536 L2168.08537,536 C2167.35142,528.821499 2171.3501,524.184874 2180.08142,522.090125 Z",
      "id": "player1_right_shoe_5",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2179.73995,521.572676 C2183.5872,520.639953 2199.27418,510.49235 2200.09021,509.401563 C2200.90624,508.310777 2201.13765,504.143534 2201.8634,496.452793 C2203.27233,494.693229 2210.45733,494.16234 2211.6384,496.980503 C2212.81947,499.798667 2210.97691,505.201474 2208.0049,510.470097 C2205.0329,515.73872 2192.47276,522.587962 2187.57974,524.370574 C2182.68672,526.153185 2176.92958,523.809087 2179.73995,521.572676 Z",
      "id": "player1_right_shoe_4",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "player1_right_shoe_3",
      "fill": "#A4CA7A",
      "points": "2195 512.464261 2198.4453 510 2204 516.165369 2200.50568 519"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "player1_right_shoe_2",
      "fill": "#A4CA7A",
      "points": "2186 518.464261 2189.4453 516 2195 522.165369 2191.50568 525"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2223,519 C2204.2483,519.049543 2188.70431,529.420624 2189.00427,536 C2189.79551,535.955907 2191.60958,536 2192.72305,536 C2192.7262,535.245959 2202.69577,526.422693 2223,526.422693 C2223,524.56484 2223,520.34241 2223,519 Z",
      "id": "player1_right_shoe_1",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2213,435 L2213,435 L2213,435 C2218.52285,435 2223,439.477153 2223,445 L2223,485 L2203,485 L2203,445 L2203,445 C2203,439.477153 2207.47715,435 2213,435 Z",
      "id": "player1_right_leg_bottom",
      "fill": "#A4CA7A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2214.23077,366 L2214.23077,366 L2214.23077,366 C2222.38759,366 2229,372.61241 2229,380.769231 L2229,456 L2197,456 L2199.05774,380.76371 L2199.05774,380.76371 C2199.28252,372.545448 2206.00943,366 2214.23077,366 Z",
      "id": "player1_right_leg_top",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "player1_left_sock",
      "fill": "#CDF1A5",
      "x": "2236",
      "y": "485",
      "width": "20",
      "height": "29"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2214.08142,522.090125 C2218.00342,521.149189 2227.3387,515.072883 2234.80287,509.738472 C2239.75142,511.233785 2252.28576,511.360007 2257.16486,509.738472 C2259.43165,508.985123 2261.41416,508.14194 2261.95084,510.902703 C2262.30863,512.743212 2260.7133,513.908921 2257.16486,514.399831 L2257.16486,536 L2202.08537,536 C2201.35142,528.821499 2205.3501,524.184874 2214.08142,522.090125 Z",
      "id": "player1_left_shoe_5",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2212.73995,521.572676 C2216.5872,520.639953 2232.27418,510.49235 2233.09021,509.401563 C2233.90624,508.310777 2234.13765,504.143534 2234.8634,496.452793 C2236.27233,494.693229 2243.45733,494.16234 2244.6384,496.980503 C2245.81947,499.798667 2243.97691,505.201474 2241.0049,510.470097 C2238.0329,515.73872 2225.47276,522.587962 2220.57974,524.370574 C2215.68672,526.153185 2209.92958,523.809087 2212.73995,521.572676 Z",
      "id": "player1_left_shoe_4",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "player1_left_shoe_3",
      "fill": "#A4CA7A",
      "points": "2229 512.464261 2232.4453 510 2238 516.165369 2234.50568 519"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "player1_left_shoe_2",
      "fill": "#A4CA7A",
      "points": "2220 518.464261 2223.4453 516 2229 522.165369 2225.50568 525"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2256,519 C2237.2483,519.049543 2221.70431,529.420624 2222.00427,536 C2222.79551,535.955907 2224.60958,536 2225.72305,536 C2225.7262,535.245959 2235.69577,526.422693 2256,526.422693 C2256,524.56484 2256,520.34241 2256,519 Z",
      "id": "player1_left_shoe_1",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2246,435 L2246,435 L2246,435 C2251.52285,435 2256,439.477153 2256,445 L2256,485 L2236,485 L2236,445 L2236,445 C2236,439.477153 2240.47715,435 2246,435 Z",
      "id": "player1_left_leg_bottom",
      "fill": "#A4CA7A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2244.76923,366 L2244.76923,366 L2244.76923,366 C2252.99057,366 2259.71748,372.545448 2259.94226,380.76371 L2262,456 L2230,456 L2230,380.769231 L2230,380.769231 C2230,372.61241 2236.61241,366 2244.76923,366 Z",
      "id": "player1_left_leg_top",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2199,366 L2259,366 L2259,391 L2259,391 C2259,398.179702 2253.1797,404 2246,404 L2212,404 L2212,404 C2204.8203,404 2199,398.179702 2199,391 L2199,366 Z",
      "id": "player1_hip",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2229.61129,271 C2234.86361,271 2250.68752,273.560077 2255.00624,276.958578 C2256.155,288.967337 2261.97756,384.152185 2260.85771,390.68918 C2253.62152,392.862028 2205.31414,391.953805 2197,390.68918 C2197.95195,383.960179 2203.1475,296.654767 2204.98191,276.958578 C2213.06424,272.756053 2224.35896,271 2229.61129,271 Z",
      "id": "player1_shirt_3",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "player1_shirt_2",
      "fill": "#80A259",
      "points": "2218.95652 307 2229.69565 307 2229.69565 336.454545 2233 336.454545 2233 343 2215.65217 343 2215.65217 335.636364 2218.95652 335.636364 2218.95652 313.545455 2214 313.545455"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2229.84837,271 C2232.51711,271 2237.83988,271.562052 2242.9816,272.290961 C2247.89591,272.987632 2244.21466,289.740272 2227.75042,289.997283 C2211.28619,290.254294 2212.43928,272.192842 2216.77253,271.690946 C2221.84159,271.103825 2227.03441,271 2229.84837,271 Z",
      "id": "player1_shirt_1",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2247.775,380.074356 C2247.75867,382.452001 2246.1541,383.77755 2244.60248,386.58316 C2242.79214,389.856613 2243.00619,395.72194 2241,400.681813 C2241.5802,401.821095 2245.03931,399.671922 2245.74296,397.679116 C2246.44662,395.68631 2246.98012,394.066966 2247.22437,393.562814 C2247.46862,393.058662 2248.07716,393.093282 2248.26335,393.569305 C2248.44954,394.045328 2248.92715,411.353964 2249.30949,412.20215 C2249.69183,413.050337 2251.8073,413.080485 2252.17189,412.20215 C2252.53648,411.323816 2252.48698,397.629061 2252.66554,397.262524 C2252.8441,396.895986 2253.3091,397.072403 2253.50541,397.262524 C2253.70171,397.452644 2253.36312,412.081846 2253.67898,412.626244 C2253.99485,413.170641 2256.1796,413.076302 2256.41591,412.626244 C2256.65223,412.176186 2256.73334,397.593576 2256.9709,397.262524 C2257.20846,396.931471 2257.68981,396.968543 2257.88674,397.262524 C2258.08366,397.556504 2257.54627,411.598899 2257.88674,412.20215 C2258.2272,412.805402 2260.34547,412.814922 2260.54038,412.20215 C2260.73528,411.589379 2261.16775,397.467646 2261.37293,397.262524 C2261.57811,397.057401 2261.85412,397.076586 2262.04965,397.262524 C2262.24518,397.448461 2262.45207,407.995837 2262.79004,408.569084 C2263.12801,409.142331 2264.73116,409.277781 2264.96748,408.569084 C2265.20379,407.860386 2264.07379,382.148862 2264.10526,380.721981 C2264.21011,375.966803 2261.4373,371 2255.87413,371 C2250.31096,371 2247.81005,374.96856 2247.775,380.074356 Z",
      "id": "player1_left_hand",
      "fill": "#A4CA7A"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "player1_left_arm_bottom",
      "fill": "#A4CA7A",
      "x": "2247",
      "y": "331",
      "width": "16",
      "height": "57",
      "rx": "8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "player1_left_arm_top",
      "fill": "#A4CA7A",
      "x": "2247",
      "y": "280",
      "width": "16",
      "height": "70",
      "rx": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2222.49108,264.553784 C2223.15837,268.849064 2222.49108,274.219161 2218.65086,274.219161 C2218.20504,276.521512 2215.35865,286.737306 2226.49778,286.994076 C2237.63691,287.250847 2239.95893,279.099982 2240,274.219161 C2235.67294,274.219161 2234.64755,269.353029 2235.67294,264.553784 C2234.39873,261.091015 2224.27034,261.206956 2222.49108,264.553784 Z",
      "id": "player1_neck",
      "fill": "#A4CA7A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2258.87036,233.512005 C2260.59886,232.492487 2263.08029,231.197331 2265.89371,233.512005 C2268.30019,235.491878 2266.49125,243.25913 2263.245,247.56061 C2260.02952,251.821322 2254.79893,252.705928 2252.74586,251.072761 C2248.41436,260.864511 2237.37523,266.064141 2229.99772,265.999403 C2210.24657,265.826085 2202,245.776193 2202,229.121817 C2202,202.852543 2212.46911,194.000654 2229.99772,194.000654 C2245.73071,193.914807 2263.19374,202.253346 2258.87036,233.512005 Z",
      "id": "player1_face",
      "fill": "#A4CA7A",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "player1_mouth_bottom"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2220.32575,259 C2221.47905,259 2231.49181,259 2232.78027,259 C2234.06873,259 2229.44625,257 2225.29344,257 C2221.14062,257 2219.17245,259 2220.32575,259 Z",
      "fill": "#94B96B",
      "transform": "translate(2226.500000, 258.000000) scale(1, -1) translate(-2226.500000, -258.000000) "
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2218.42598,256 C2219.93415,256 2233.02775,256 2234.71266,256 C2236.39757,256 2230.35279,253 2224.92219,253 C2219.49158,253 2216.91782,256 2218.42598,256 Z",
      "id": "player1_mouth_top",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2223.11476,232.36351 C2223.11476,230.622578 2227.38629,230.470015 2227.38839,232.36351 C2227.39049,234.257006 2228.76206,244.137261 2227.39049,245.892944 C2226.01891,247.648627 2221.987,247.060391 2221.36303,245.892944 C2220.73906,244.725498 2220.85672,242.821655 2222.21024,242.291318 C2223.56376,241.760981 2223.11476,234.104443 2223.11476,232.36351 Z",
      "id": "player1_nose",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2234,235.594484 C2236.28918,229.033766 2246.47003,228.032491 2248,233.713778 C2248.00726,241.385327 2235.66412,242.062908 2234,235.594484 Z",
      "id": "player1_left_eye_whites",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "player1_left_pupil",
      "fill": "#6D8C4A",
      "cx": "2243.5",
      "cy": "234.5",
      "r": "3.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2221,235.594484 C2218.71082,229.033766 2208.52997,228.032491 2207,233.713778 C2206.99274,241.385327 2219.33588,242.062908 2221,235.594484 Z",
      "id": "player1_right_eye_whites",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "player1_right_pupil",
      "fill": "#6D8C4A",
      "cx": "2214.5",
      "cy": "234.5",
      "r": "3.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2186.5602,233.863302 C2199.39473,243.220443 2210.67544,234.811615 2209.65586,227.278804 C2213.87712,234.811615 2230.31095,233.117504 2232.31825,222.854752 C2233.78122,234.811615 2252.49372,233.229966 2255.38041,227.278804 C2257.66666,238.617552 2270.82475,238.759576 2275.22043,234.811615 C2290.43763,221.14434 2280.49654,206 2269.49286,206 C2276.74543,190.276411 2258.08237,176.364999 2245.93979,185.713261 C2244.32018,170.768133 2216.07805,169.437197 2211.94787,185.713261 C2199.34062,181.472276 2187.7237,193.491821 2193.2812,206 C2181.75382,205.635134 2173.72567,224.506161 2186.5602,233.863302 Z",
      "id": "player1_hair",
      "fill": "#6D8C4A"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7d66a94","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_3/svg/background/player1ModThree.vue
// module id = 743
// module chunks = 1